import { createContext, useContext, useState, useCallback } from "react";
import translations from "@/translations";
import innerTranslations from "@/translations-inner";

// Deep merge inner translations into main
const merged = {};
for (const lang of Object.keys(translations)) {
  merged[lang] = { ...translations[lang], ...(innerTranslations[lang] || {}) };
}

const rtlLanguages = ["ar"];
const languageNames = { en: "English", ar: "العربية", de: "Deutsch", fr: "Français", hi: "हिन्दी" };

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("flarial-lang") || "en");
  const isRTL = rtlLanguages.includes(lang);

  const changeLang = useCallback((newLang) => {
    setLang(newLang);
    localStorage.setItem("flarial-lang", newLang);
    document.documentElement.dir = rtlLanguages.includes(newLang) ? "rtl" : "ltr";
    document.documentElement.lang = newLang;
  }, []);

  const t = useCallback((path) => {
    const keys = path.split(".");
    let val = merged[lang];
    for (const k of keys) {
      val = val?.[k];
    }
    if (val !== undefined) return val;
    let fallback = merged.en;
    for (const k of keys) {
      fallback = fallback?.[k];
    }
    return fallback || path;
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, changeLang, t, isRTL, languageNames, languages: Object.keys(merged) }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage must be used within LanguageProvider");
  return ctx;
}
